import React, { Component } from "react"
import { Query } from "react-apollo"
import GET_VIEWER from "../../graphql/getViewer.graphql"
import "./account.scss"
import Modal from "../../components/Modal"
import EditPasswordModal from "../../components/EditPasswordModal"
import EditProfileModal from "../../components/EditProfileModal"
import EditDeviceModal from "../../components/EditDeviceModal"
import Loading from "../../components/Loading"

class Account extends Component {
  state = {
    modalIsOpen: false,
    modalContent: "",
  }

  handleEditAccount = (e) => {
    e.preventDefault()

    this.setState({
      modalIsOpen: true,
      modalContent: "account",
    })
  }

  handleEditPassword = (e) => {
    e.preventDefault()

    this.setState({
      modalIsOpen: true,
      modalContent: "password",
    })
  }

  handleEditDevices = () => {
    this.setState({
      modalIsOpen: true,
      modalContent: "devices",
    })
  }

  handleCloseModal = () => {
    this.setState({
      modalIsOpen: false,
      modalContent: "",
    })
  }

  componentDidMount = () => {
    this.props.trackPage("Your Account")
  }

  renderModalContent = () => {
    let content = ""

    switch (this.state.modalContent) {
      case "account":
        content = (
          <EditProfileModal
            viewer={this.props.data.viewer}
            close={this.handleCloseModal}
          />
        )
        break
      case "password":
        content = (
          <EditPasswordModal
            viewer={this.props.data.viewer}
            close={this.handleCloseModal}
          />
        )
        break
      case "devices":
        content = (
          <EditDeviceModal
            viewer={this.props.data.viewer}
            close={this.handleCloseModal}
          />
        )
        break
    }

    return content
  }

  render() {
    const {
      name,
      email,
      phone,
      userId,
      deviceLimit,
      devices,
    } = this.props.data.viewer
    return (
      <div className="account-container">
        <div className="account-info-container">
          <h1>Profile</h1>
          <p className="account-info">
            Name:<span>{name}</span>
          </p>
          <p className="account-info">
            Email:<span>{email}</span>
          </p>
          <p className="account-info">
            Phone:<span>{phone}</span>
          </p>
          <p className="account-info">
            Account#:<span>{userId}</span>
          </p>
          <button onClick={this.handleEditAccount}>EDIT</button>
        </div>
        <div className="account-info-container">
          <h1>Login & Security</h1>
          <p className="account-info">
            Username:<span>{email}</span>
          </p>
          <p className="account-info">
            Password:<span>********</span>
          </p>
          <button onClick={this.handleEditPassword}>EDIT PASSWORD</button>
        </div>
        <div className="account-info-container">
          <h1>Devices</h1>
          <p className="account-info">
            Device Limit:<span>{deviceLimit}</span>
          </p>
          <p className="account-info" data-cy="number-of-registered-devices">
            Registered Devices:<span>{devices.length}</span>
          </p>
          <button onClick={this.handleEditDevices} data-cy={"edit-devices"}>
            EDIT DEVICES
          </button>
        </div>
        <Modal
          isOpen={this.state.modalIsOpen}
          close={this.handleCloseModal}
          classes={["medium"]}
        >
          {this.renderModalContent()}
        </Modal>
      </div>
    )
  }
}

const AccountWithData = (componentProps) => (
  <Query query={GET_VIEWER}>
    {(queryProps) => {
      if (queryProps.error) {
        console.log("account error: ", queryProps.error)
        return null
      }

      if (queryProps.loading && !queryProps.data.viewer) {
        return <Loading />
      }

      return <Account {...componentProps} {...queryProps} />
    }}
  </Query>
)

export default AccountWithData
